import React, { useState, useEffect, useRef } from 'react';
import { feachDocument, updateDocument,totalDevices,graphData,graphdataPost} from '../services/api';
import Skeleton from 'react-loading-skeleton';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { FaAngleDown ,FaAngleUp,FaEyeSlash} from "react-icons/fa6";

const GraphData = () => {
     const[loading,setLoading]=useState(false);
    const [isDisabled, setIsDisabled] = useState(true);
  const [device, setDevice] = useState([]);
 const [deviceId,setDeviceId]=useState();
 const [content,setcontent]=useState('');
 const [deviceSubmit,setdeviceSubmit]=useState(false);
  useEffect(() => {
    totalDevices()
      .then((res) => {
        setDevice(res.data);
      })
      .catch((err) => console.error(err));
  }, []);

 

  const handleSave = (id, index) => {
    const docToUpdate = documents[index];
    updateDocument(id, {
      title: docToUpdate.title,
      content: docToUpdate.updatedContent,
    })
      .then(() => toast.success("Document saved!"))
      .catch((err) => {
        console.error(err);
        toast.error("Error saving document.");
      });
  };

    const [deviceSelectedText, setDeviceSelectedText] = useState('');
      const [deviceOpen, setDeviceOpen] = useState(false);
  const toggleDropdown = (name) => {
    const stateSetters = {
      device: setDeviceOpen,
    };
  
    Object.entries(stateSetters).forEach(([key, setter]) => {
      setter(key === name ? (prev) => !prev : false);
    });
  };
  

  const handleButtonSubmit = async () => {
    setLoading(true);
    setcontent('');
console.log('test');
    graphData(deviceId).then((res)=>
    {
    
        setLoading(false);
        setdeviceSubmit(true);
        {res.data? setcontent(res.data.jsondata):''}
        setcontent(res.data.jsondata);
 
   

    }
    ).catch((err)=>
    {

    });
  }

  const handleUpdateSubmit = async () => {
    setLoading(true);
    let data={
        device_id:deviceId,
        jsondata:JSON.stringify(content)
    }
    graphdataPost(data).then((res)=>
        { 
            setLoading(false);
            setdeviceSubmit(true);
        toast.success("Document saved!")
            console.log(data); }
        ).catch((err)=>
        {});




  }

 
const handleSelect = (id,text) => {
setdeviceSubmit(false);
setDeviceSelectedText(text)
setDeviceId(id);
setDeviceOpen(false);
setIsDisabled(false);

  }
  return (
    <div className="p-0 mt-0 pb-4">
      {/* index.js already mounts a ToastContainer for the whole app, so the
          page-level one here was a duplicate. */}

<div>


<div className="flex flex-col gap-6 xl:flex-row xl:items-start">
<section className="w-full xl:w-[340px] xl:shrink-0">
                <div className="flex w-full flex-col rounded-lg border border-bgray-200 bg-white p-5 dark:border-darkblack-400 dark:bg-darkblack-600">
                <div className="w-full">
<p className="mb-2 text-base font-bold leading-[24px] text-bgray-900 dark:text-white">
Device 
                          </p>
      <div className="relative h-[56px] w-full">
        {/* start  */}
      <button
      onClick={() => toggleDropdown('device')}
        type="button"
        className="relative flex h-full w-full items-center justify-between rounded-lg bg-bgray-100 px-4 dark:bg-darkblack-500"
      >
        <span className={`text-base ${deviceSelectedText ? 'text-bgray-700' : 'text-bgray-500'}`}
        > {deviceSelectedText || 'Select Device'}</span>
 
        {!deviceOpen?<FaAngleDown style={{ color: '#a0aec0' }} />:<FaAngleUp style={{ color: '#a0aec0' }} />}
 
      </button>
    
      {deviceOpen  && (
        <div
          id="province-filter"
          className="absolute right-0 top-14 z-10 w-full overflow-hidden rounded-lg bg-white shadow-lg dark:bg-darkblack-500"
        >
       
          <ul className="overflow">
  {device ? (
    device.map((row) => (
      <li
        key={row.id}
        onClick={() => handleSelect(row.id,row.name)}
        className="cursor-pointer px-5 py-2 text-sm font-semibold text-bgray-900 hover:bg-bgray-100 dark:text-white hover:dark:bg-darkblack-600"
      >

     
        {row.name}
      </li>
    ))
  ) : (
    <Skeleton
      style={{
        lineHeight:3,
      }}
      count={1}
    />
  )}
</ul>

       
        </div>
      )}

</div>
 
 
 



                        </div>
 
 
  {/* Submit Button */}
 
{!deviceSubmit?(
    <>
 
<button
className="mt-5 flex w-full items-center justify-center gap-2 rounded-lg bg-success-300 px-6 py-2.5 text-base font-semibold text-white transition-colors
           hover:bg-success-400
           disabled:cursor-not-allowed disabled:bg-bgray-300 disabled:text-bgray-600"
disabled={isDisabled}
onClick={handleButtonSubmit}
>
{loading && (
    <svg
      className="animate-spin h-5 w-5 text-white"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="4"
      />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
      />
    </svg>
  )}
  {loading ? "Loading..." : "Submit"}
</button>
</>
):(<>
<button
className="mt-5 flex w-full items-center justify-center gap-2 rounded-lg bg-success-300 px-6 py-2.5 text-base font-semibold text-white transition-colors
           hover:bg-success-400
           disabled:cursor-not-allowed disabled:bg-bgray-300 disabled:text-bgray-600"
disabled={isDisabled}
onClick={handleUpdateSubmit}
>
{loading && (
    <svg
      className="animate-spin h-5 w-5 text-white"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="4"
      />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
      />
    </svg>
  )}
  {loading ? "Loading..." : "Update"}
</button>

</>)}


  {/* Export PDF Button */}

 {/* {console.log(loadingDoc)} */}



 
 
 

 
 
 

          </div>
          </section>

<section className="w-full min-w-0 flex-1">
                <div className="flex w-full flex-col rounded-lg border border-bgray-200 bg-white p-5 dark:border-darkblack-400 dark:bg-darkblack-600">
 


                <textarea
        id="my-textarea"
        value={content}
        onChange={(e) => setcontent(e.target.value)}
        rows="30"
        className="w-full rounded-lg border-0 bg-bgray-100 px-4 py-4 font-mono text-sm text-bgray-800 focus:outline-none focus:ring-2 focus:ring-green-200 dark:bg-darkblack-500 dark:text-white"
        placeholder="Type something here..."
      />
 

 </div>


</section>
 
 

  </div>
 
    </div>
   

    </div>
  );
};

export default GraphData;
